import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import compose_logo from "../../imgs/compose_logo_half.svg";
import compose_logo_light from "../../imgs/compose_logo_light_half.svg";
export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const LogoLink = styled(NavLink)`
  margin-right: auto;
`;

const ComposeLogo = styled.div`
position: absolute;
left: 2rem;
top: 1rem;
background: url(${(props) => props.theme.themeType === "dark" ? compose_logo: compose_logo_light}) no-repeat;
width: 15rem;
height: 4rem;
z-index: 1;
`;
const ComposeLogoLink = () => {
  return (
    <LogoLink to="/">
      <ComposeLogo />
    </LogoLink>
  );
};

export default ComposeLogoLink;
